import { showToast } from '../../../toasts';
import { FORM_ERROR_MSG } from'../../../../types/types';
import { TERMINAL_FORM } from '../form-terminal-types';
import { validateForm, getTerminalData } from '../from-terminal-helpers';

import { ITerminalInsertUpdate } from '../../../../models/terminal.interface';
import { awsPostNewTerminal } from '../../../../routes/post-new-terminal';

/**
 * Posts data to the AWS api route to add a new terminal
 * 
 * @returns void
 */
export const addNewTerminal = () => {
  const { 
    terminalForm, 
    terminalSubmitButton, 
    terminalPartnerSelect, 
    terminalAddressState, 
    terminalBillingType, 
    terminalStatus,
    terminalName,
  } = TERMINAL_FORM;

  const postNewTerminal = async (awsData: ITerminalInsertUpdate) => {
    const { body } = await awsPostNewTerminal(awsData);

    if ( body ) {
      showToast('aafp_toast', `${terminalName.value} has been added`);
      setTimeout(() => {
        location.href = '/terminals/';
      }, 2000);
    }
  }

  terminalForm.addEventListener('submit', e => {
    e.preventDefault();
    e.stopPropagation();

    if ( validateForm(terminalForm, [terminalPartnerSelect, terminalAddressState, terminalBillingType, terminalStatus]) ) {
      terminalForm.classList.remove('was-validated');
      terminalForm.classList.remove('form-control:valid');
      terminalSubmitButton.classList.add('aafp_button-loading');
      FORM_ERROR_MSG.innerHTML = '';

      // const partnerData = terminalPartnerSelect.getAttribute('data-value') != '' ? 
      //                   terminalPartnerSelect.getAttribute('data-value') : 
      //                   terminalPartner.value;

      // const { userId } = useAuth()!;

      // const formmatedTerminalNotes = terminalNotes.value.replace(/\n/g, '\\n');
      // const formmatedInternalNotes = terminalInternalNotes.value.replace(/\n/g, '\\n');

      // const publicPrivate = terminalPublic.getAttribute('data-value') === 'Public' ? 1 : 0;

      // const awsModelData = {
      //   iuUserId: userId,
      //   iuTerminalId: terminalName.value,
      //   iuPartnerId: Number(partnerData),
      //   iuTerminalName: terminalDescription.value,
      //   iuCostCents: terminalCostCents.valueAsNumber,
      //   iuDefaultMargin: terminalMarginCents.valueAsNumber,
      //   iuLimitGallons: terminalGallonLimit.valueAsNumber,
      //   iuAddressOne: terminalAddressOne.value,
      //   iuAddressTwo: terminalAddressTwo.value,
      //   iuAddressCity: terminalAddressCity.value,
      //   iuAddressState: String(terminalAddressState.getAttribute('data-value')),
      //   iuAddressZip: terminalAddressZip.value,
      //   iuStatus: Number(terminalStatus.getAttribute('data-value')),
      //   iuPublicTerminal: publicPrivate,
      //   iuNational: terminalNational.checked === true ? '1' : '0',
      //   iuOutOfService: terminalOutOfService.checked === true ? 1 : 0,
      //   iuBillingType: String(terminalBillingType.getAttribute('data-value')),
      //   iuTransactionFee: terminalTransactionFee.valueAsNumber,
      //   iuTerminalFee: terminalFee.valueAsNumber,
      //   iuRegion: terminalRegion.value,
      //   iuServicingBranch: terminalSvcBranch.value,
      //   iuCustomerList: terminalCustList.value.replace(/\n/g, '\\n'),
      //   iuContactName: terminalContactName.value,
      //   iuContactPhone: terminalContactPhone.value,
      //   iuContactEmail: terminalContactEmail.value,
      //   iuContactNameTwo: terminalContactNameTwo.value,
      //   iuContactPhoneTwo: terminalContactPhoneTwo.value,
      //   iuContactEmailTwo: terminalContactEmailTwo.value,
      //   iuContactNameThree: terminalContactNameThree.value,
      //   iuContactPhoneThree: terminalContactPhoneThree.value,
      //   iuContactEmailThree: terminalContactEmailThree.value,
      //   iuNotes: formmatedTerminalNotes,
      //   iuTerminalSerialNum: terminalSerialNum.value,
      //   iuIpAddress: terminalIpAddress.value,
      //   iuOrderedDate: terminalOrderedDate.value,
      //   iuMoniterSerialNumber: terminalMonitorSerialNumber.value,
      //   iuGpsLatitude: terminalGPSLatitude.value,
      //   iuGpsLongitude: terminalGPSLongitude.value,
      //   iuInternalNotes: formmatedInternalNotes,        
      //   iuAccessDescription: terminalAccessDesc.value
      // }
      const awsModelData = getTerminalData(terminalName.value, {}, TERMINAL_FORM);
      postNewTerminal(awsModelData);
    }
  });
}

